import { FC } from "react";
import { Stack } from "@chakra-ui/react";

import { NotFoundIcon } from "../../../icons";
import { ErrorTemplate } from "../blocks/ErrorTemplate";

export const PageNotFound: FC = () => {
  const message = "В адресе есть ошибка или страница удалена";

  return (
    <Stack mt="20px">
      <ErrorTemplate
        error={null}
        icon={NotFoundIcon}
        header="Страница не найдена"
        message={message}
        showReloadButton={false}
      />
    </Stack>
  );
};
